<div class="wrapper">
    <div class="chat-types">
        <div class="chat-type" 
            [ngClass]="{'selected' : selectedChatType === 'CUSTOMER_SERVICE' }"
            (click)="selecteChatType('CUSTOMER_SERVICE')">CUSTOMER SERVICE</div>
        <div class="chat-type" 
            [ngClass]="{'selected' : selectedChatType === 'YORKSTONE_CHAT' }"
            (click)="selecteChatType('YORKSTONE_CHAT')">YORKSTONE CHAT</div>
    </div>
    <div class="search-chats-view search-scrolled-view">
        <div *ngIf="(isLoading$ | async)"
            class="spinner-wrapper">
            <mat-spinner [diameter]="25"></mat-spinner>
        </div>
        <app-empty-result *ngIf="!(isLoading$ | async) && !selectedChats.length"></app-empty-result>

        <ng-container *ngIf="!(isLoading$ | async) && selectedChats?.length">
            <div class="account-item-wrapper"
                *ngFor="let chat of selectedChats">
                <div class="account-item">
                    <div class="account-item-icon">
                        <img class="account-item-icon-image" src="assets/images/icon-chat-person.svg" />
                    </div>
                    <div class="account-item-text">
                        <div class="account-item-name">{{ chat.createdByName }}</div>
                        <div class="account-item-subject">{{ chat.name }}</div>
                    </div>
                    <div class="account-item-r-part">
                        <div class="account-item-activity">
                            <div class="account-item-indicator" [ngClass]="{ 'active': chat.online }"></div>
                            <div class="account-item-time">{{ chat.lastAction | date : 'hh:mm, d MMM y' }}</div>
                        </div>
                        <div class="account-item-link-holder" (click)="goToChat(chat)">
                            <a class="account-item-link">View chat</a>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="search-chats-view-bottom" *ngIf="!(isLoading$ | async) && archiveCnt">
        <div class="chats-archive">
            <div class="chats-archive-icon-holder">
                <img class="chats-archive-icon" src="assets/images/icon-circle-i.svg">
            </div>
            <div class="chats-archive-text" (click)="gotToArchive()">{{ archiveCnt }} archived chats found&nbsp;<a class="chats-archive-link">See all archived</a><div>
        </div>
    </div>
</div>
